import { RoverBrand } from '@rover/types';
import getRoverBrand from '@rover/utilities/getRoverBrand';

// Keep this in sync if RoverBrand enum in @rover/types/src/RoverBrand.ts changes
const BRAND_SPECIFIC_VALUE_KEYS = {
  [RoverBrand.Rover]: 'rover',
  [RoverBrand.CatInAFlat]: 'catInAFlat',
  [RoverBrand.DogBuddy]: 'dogBuddy',
} as const satisfies Record<RoverBrand, string>;

export type BrandSpecificValueKey =
  (typeof BRAND_SPECIFIC_VALUE_KEYS)[keyof typeof BRAND_SPECIFIC_VALUE_KEYS];

export type BrandSpecificValueInput<T = string> = {
  [key in BrandSpecificValueKey]?: NonNullable<T>;
} & {
  rover: NonNullable<T>;
};

const getBrandSpecificValue = <T = string>(
  input: BrandSpecificValueInput<T>,
  brand?: RoverBrand
): T => {
  // If brand is not provided, determine it using getRoverBrand.
  // If possible, pass the brand from context for better performance.
  const resolvedBrand = brand ?? getRoverBrand();

  return input[BRAND_SPECIFIC_VALUE_KEYS[resolvedBrand]] ?? input.rover;
};

export default getBrandSpecificValue;
